var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-0"},[_vm._m(0),_c('service-intros'),_c('streak'),_c('Why')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"grad-border"},[_c('div',{staticClass:"logo-box"},[_c('img',{staticClass:"logo",attrs:{"alt":"logo","src":require("../assets/logo.svg")}})])])])])
}]

export { render, staticRenderFns }